import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table, Popup, Icon } from "semantic-ui-react";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../marking/ResourceMarker.jsx";
import ResourceIcon from "./resourceIcon/ResourceIcon.jsx";
import StartStopPowerIconControl from "./startStopControl/StartStopPowerIconControl.jsx";

import {
  ACTION_URI_CHUNKS,
  RESOURCE_URI_CHUNKS
} from "../../constants/entity.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ResourceTable extends PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired,
    handleStartStopClick: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  renderStartStopControl = data => {
    const { permissions, handleStartStopClick, disabled, copy } = this.props;

    return (
      <StartStopPowerIconControl
        data={data}
        permissions={permissions}
        circular={true}
        onClick={handleStartStopClick}
        disabled={disabled}
        copy={copy("resource.start_stop_button")}
      />
    );
  };

  renderResourceRows = data => {
    const { handleDelete, copy } = this.props;

    if (!data || data.length < 1) return null;

    return data.map(item => {
      if (!item) return null;

      const createImagePath = `/${RESOURCE_URI_CHUNKS.IMAGES}/${ACTION_URI_CHUNKS.CREATE}${item["@id"]}`;

      return (
        <Table.Row key={item["@id"]} textAlign="center">
          <Table.Cell textAlign="left">
            <ResourceIcon data={item} size="large" />
          </Table.Cell>

          {this.renderInfo(item)}

          <Table.Cell collapsing>
            {this.renderStartStopControl(item)}
          </Table.Cell>
          <Table.Cell collapsing>
            <ActionDropdownMenu
              viewPath={`/resources${item["@id"]}`}
              createImagePath={createImagePath}
              onDelete={handleDelete}
              data={item}
              copy={copy("basic_resource_actions")}
            />
          </Table.Cell>
          <Table.Cell verticalAlign="middle" collapsing>
            <ResourceMarker
              marking={item.marking}
              circular={true}
              style={{ display: "block" }}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  render() {
    const { copy, data } = this.props;

    if (!data || data.length < 1) {
      return (
        <p className="clear-both">{copy(`project.no_resources_available`)}</p>
      );
    }

    return (
      <Table className="clear-both" unstackable>
        <Table.Body>{this.renderResourceRows(data)}</Table.Body>
      </Table>
    );
  }

  renderInfo = data => {
    const { copy } = this.props;

    return (
      <Table.Cell collapsing>
        {data.description && (
          <Popup
            trigger={<Icon name="info circle" className="info" />}
            content={this.renderDescription(data)}
            position="top right"
            offset={[11, 0]}
            wide
          />
        )}
      </Table.Cell>
    );
  };

  renderDescription = data => {
    return <p style={{ whiteSpace: "pre-line" }}>{data.description}</p>;
  };
}

const mapStateToProps = state => ({
  permissions: state.account.permissions,
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourceTable);
